import type {RootState} from '../index'

export const selectConfirmDialog = (state: RootState) => state.ui.confirmDialog
export const selectOpenDropdownId = (state: RootState) => state.ui.openDropdownId
export const selectOpenModal = (state: RootState) => state.ui.openModal
export const selectGlobalLoading = (state: RootState) => state.ui.globalLoading
export const selectIsEditorFocused = (editorId: string) => (state: RootState) => state.ui.focusedEditorId === editorId
export const selectSignInError = (state: RootState) => state.ui.signInError
export const selectResetPasswordError = (state: RootState) => state.ui.resetPasswordError
export const selectIsMobileSidebarOpen = (state: RootState) => state.ui.isMobileSidebarOpen
export const selectIsLoading = (key: string) => (state: RootState) => state.ui.loading.includes(key)
export const selectTeamColumns = (state: RootState) => state.ui.teamColumns

export const selectIsGuestModified = (state: RootState) => state.ui.isGuestModified
